"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchPavementTypeState = exports.setPavementTypeState = void 0;
// 舗装タイプの対応表
var PAVEMENT_TYPE = {
    密粒舗装: '0',
    開粒舗装: '1'
};
// 舗装タイプのラジオボタンの状態をlocalStorageに保存
var setPavementTypeState = function () {
    console.log('setPavementTypeState');
    var sendButton = document.querySelector('input#gform_next_button_1_12, input#gform_next_button_28_12');
    if (sendButton === null)
        return; // input#gform_next_button_{1|28}_12 がない場合は何もしない
    var savePavementType = function () {
        var radio = document.querySelector('input[name="input_11"]:checked');
        // 密粒舗装 = 0, 開粒舗装 = 1, エラー = null
        if (radio !== null) {
            localStorage.setItem('Pavement_type', PAVEMENT_TYPE[radio.value]);
        }
    };
    // input#gform_next_button_{1|28}_12 がクリックされたとき
    sendButton.addEventListener('click', savePavementType);
    // input#gform_next_button_{1|28}_12 がEnterキーで送信されたとき
    sendButton.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
            savePavementType();
        }
    });
};
exports.setPavementTypeState = setPavementTypeState;
var fetchPavementTypeState = function () {
    var _a;
    // 密粒舗装 = 0, 開粒舗装 = 1, エラー = null
    return (_a = localStorage.getItem('Pavement_type')) !== null && _a !== void 0 ? _a : null;
};
exports.fetchPavementTypeState = fetchPavementTypeState;
